export default __webpack_public_path__ + "static/media/add_content_plus_icon.378f9639.svg";